import { Switch } from '@/components/ui/switch';

interface SearchableToggleProps {
  isSearchable: boolean;
  onToggle: (checked: boolean) => void;
}

export function SearchableToggle({ isSearchable, onToggle }: SearchableToggleProps) {
  return (
    <div className="bg-slate-100/80 rounded-xl sm:rounded-[20px] p-4 sm:p-6">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h4 className="font-medium text-slate-900">Make profile searchable</h4>
          <p className="text-sm text-slate-500">Allow clients to find you in search results</p>
        </div>
        <Switch
          checked={isSearchable}
          onCheckedChange={onToggle}
        />
      </div>
    </div>
  );
}
